"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const emotion_1 = require("emotion");
const anchorStyle = emotion_1.css({
    margin: 0,
    padding: 0,
    border: 0,
});
const aTag = (_a) => {
    var { children, icon } = _a, rest = __rest(_a, ["children", "icon"]);
    return react_1.default.createElement("a", Object.assign({}, rest), icon || children);
};
const buttonTag = (_a) => {
    var { children, icon } = _a, rest = __rest(_a, ["children", "icon"]);
    return react_1.default.createElement("button", Object.assign({}, rest), icon || children);
};
const Button = (_a) => {
    var { blockLevel, className, disabled, href, icon, onClick, size, target, variant } = _a, rest = __rest(_a, ["blockLevel", "className", "disabled", "href", "icon", "onClick", "size", "target", "variant"]);
    const typeClasses = (variant) === 'anchor' ? emotion_1.cx(anchorStyle, 'btn-link') : `btn btn-${variant}`;
    const iconClass = size === 'default' ? 'btn-icon-md' : `btn-icon-${size}`;
    const baseSizeClass = size === 'default' ? '' : `btn-${size}`;
    const sizeClass = icon ? iconClass : baseSizeClass;
    const classes = emotion_1.cx(className, typeClasses, { 'btn-block': blockLevel }, sizeClass);
    return href
        ? aTag(Object.assign({ href, target, icon, disabled, size, onClick, className: classes }, rest))
        : buttonTag(Object.assign({ disabled, icon, size, onClick, className: classes }, rest));
};
Button.propTypes = {
    variant: prop_types_1.default.oneOf(['default', 'primary', 'secondary', 'link', 'outline-secondary', 'anchor']),
    children: prop_types_1.default.node,
    disabled: prop_types_1.default.bool,
    href: prop_types_1.default.string,
    icon: prop_types_1.default.node,
    target: prop_types_1.default.oneOf(['_blank', '_parent', '_self', '_top']),
    blockLevel: prop_types_1.default.bool,
    size: prop_types_1.default.oneOf(['default', 'sm', 'lg']),
    onClick: prop_types_1.default.func,
    className: prop_types_1.default.string,
};
buttonTag.propTypes = {
    children: prop_types_1.default.node,
    icon: prop_types_1.default.node,
};
aTag.propTypes = {
    children: prop_types_1.default.node,
    icon: prop_types_1.default.node,
};
Button.defaultProps = {
    disabled: false,
    blockLevel: false,
    size: 'default',
    variant: 'default',
};
exports.default = Button;
